'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var breakpoints = exports.breakpoints = {
  sm: '(min-width: 32em)',
  md: '(min-width: 48em)',
  lg: '(min-width: 64em)'
};

var scale = exports.scale = [0, 8, 16, 32, 64];

var config = {
  breakpoints: breakpoints,
  scale: scale
};

exports.default = config;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reflexbox/dist/config.js
 ** module id = 165
 ** module chunks = 0
 **/